import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

interface NoPaymentMethodAlertProps {
  className?: string;
}

export function NoPaymentMethodAlert({ className }: NoPaymentMethodAlertProps) {
  const { t } = useTranslation();

  return (
    <Alert variant="destructive" className={className}>
      <AlertCircle className="h-4 w-4" />
      <AlertTitle>{t("charge.noPaymentMethod")}</AlertTitle>
      <AlertDescription>
        {t("charge.noPaymentMethodDescription")}
      </AlertDescription>
    </Alert>
  );
} 